import {httpService} from "@/modules/common/services"


const getCampaignWizard = async () => {
  try {
    let result = await httpService.get(`wizards`)
    return result.data.filter(item => item.name === "campaign_wizard")[0]
  } catch (e) {
    return e.response.data
  }
}

const getPaymentWizard = async () => {
  try {
    let result = await httpService.get(`wizards`)
    return result.data.filter(item => item.name === "payment_wizard")[0]
  } catch (e) {
    return e.response.data
  }
}

const updateWizardFlags = async (business_uid, wizard_uid, flags) => {
  try {
    let result = await httpService.put(`wizards/${wizard_uid}/update_flags`,flags)
    return result
  } catch (e) {
    return e.response.data
  }
}

const wizardCompleted = async (business_uid, wizard_uid) => {
  try {
    let result = await httpService.put(`wizards/${wizard_uid}/update_completed`,{completed: true})
    return result
  } catch (e) {
    return e
  }
}

export default {
  updateWizardFlags,
  getCampaignWizard,
  getPaymentWizard,
  wizardCompleted
};
